
import { motion } from "framer-motion";

export const DemoPollHeader = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="mb-6 text-center select-none"
    >
      <h2 className="heading-3 mb-2">Try a Demo Vote</h2>
      <p className="text-white dark:text-gray-200">
        Allocate 3, 2, and 1 points to your top performers
      </p>
    </motion.div>
  );
};
